import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { useAuthStore } from "../store/authStore";

/**
 * /magic?token=…&next=… — e-posta CTA'larından gelen güvenli bağlantı.
 * Token'ı normal oturuma çevirir ve hedef sayfaya yönlendirir.
 */
export default function MagicLogin() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get("token");
    let next = params.get("next") || "/app/dashboard";
    if (!next.startsWith("/")) next = "/app/dashboard";
    if (!token) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/magic-exchange", { token });
        if (data.access_token) {
          localStorage.setItem("taskora_access_token", data.access_token);
        }
        useAuthStore.setState({
          user: data.user,
          tenant: data.tenant,
          loading: false,
        });
        // Bumps the fetchMe sequence so the App-boot /auth/me (which raced
        // us without a token) can't clobber this fresh session.
        useAuthStore.getState().fetchMe();
        navigate(data.next || next, { replace: true });
      } catch {
        setError("Bağlantının süresi dolmuş veya geçersiz. Giriş sayfasına yönlendiriliyorsun…");
        setTimeout(() => navigate("/login", { replace: true }), 2500);
      }
    })();
  }, [params, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-zinc-50 px-4">
      <div className="text-center" data-testid="magic-login-page">
        {error ? (
          <p className="text-sm text-red-600" data-testid="magic-login-error">
            {error}
          </p>
        ) : (
          <>
            <Loader2 className="mx-auto h-8 w-8 animate-spin text-zinc-400" />
            <p className="mt-3 text-sm text-zinc-500" data-testid="magic-login-loading">
              Güvenli bağlantı doğrulanıyor…
            </p>
          </>
        )}
      </div>
    </div>
  );
}
